import { z } from "zod";
import { activitySchema, categorySchema, citySchema, comboSchema, adSchema } from "../activities";

export const homeResponseSchema = z.object({
  cities: z.array(citySchema),
  categories: z.array(categorySchema),
  activities: z.array(activitySchema),
  trending: z.object({
    activities: z.array(activitySchema),
    combos: z.array(comboSchema),
  }),
  nearby: z.array(activitySchema).default([]),
  combos: z.array(comboSchema).default([]),
  ads: z.array(adSchema).default([]),
  notification: z.object({ count: z.number().int().nonnegative() }).optional(),
});
export type HomeResponse = z.infer<typeof homeResponseSchema>;
